import { render, staticRenderFns } from "./product-gallery.vue?vue&type=template&id=c092352c&"
import script from "./product-gallery.vue?vue&type=script&lang=js&"
export * from "./product-gallery.vue?vue&type=script&lang=js&"
import style0 from "./product-gallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c092352c')) {
      api.createRecord('c092352c', component.options)
    } else {
      api.reload('c092352c', component.options)
    }
    module.hot.accept("./product-gallery.vue?vue&type=template&id=c092352c&", function () {
      api.rerender('c092352c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product-gallery/product-gallery.vue"
export default component.exports